module.exports = __webpack_public_path__ + "img/barcode-sample.6cd5282.png";